export default __webpack_public_path__ + "static/media/image-2.539a9faa.jpg";